// extracted by mini-css-extract-plugin
export default {"notFound":"b1846a8fd990"};